(() => {
  const storageKey = "myline-recently-viewed-products";
  const maximumProducts = 12;

  const readProducts = () => {
    try {
      const products = JSON.parse(localStorage.getItem(storageKey) || "[]");
      return Array.isArray(products) ? products : [];
    } catch (error) {
      return [];
    }
  };

  const writeCurrentProduct = () => {
    const source = document.getElementById("MylineRecentlyViewedProduct");
    if (!source) return;

    try {
      const current = JSON.parse(source.textContent);
      if (!current.handle || !current.url) return;
      const products = readProducts().filter((product) => product.handle !== current.handle);
      products.unshift(current);
      localStorage.setItem(storageKey, JSON.stringify(products.slice(0, maximumProducts)));
    } catch (error) {
      return;
    }
  };

  const createCard = (product) => {
    const card = document.createElement("a");
    card.className = "cart-recently-viewed__card";
    card.href = product.url;
    card.setAttribute("role", "listitem");

    if (product.image) {
      const image = document.createElement("img");
      image.className = "cart-recently-viewed__image";
      image.src = product.image;
      image.alt = product.image_alt || product.title;
      image.width = 240;
      image.height = 300;
      image.loading = "lazy";
      card.appendChild(image);
    }

    const title = document.createElement("span");
    title.className = "cart-recently-viewed__title";
    title.textContent = product.title;
    card.appendChild(title);

    const price = document.createElement("span");
    price.className = "cart-recently-viewed__price";
    price.textContent = typeof formatMoney === "function" ? formatMoney(product.price) : product.price_text;
    card.appendChild(price);

    return card;
  };

  const render = () => {
    document.querySelectorAll("[data-cart-recently-viewed]").forEach((container) => {
      const track = container.querySelector("[data-cart-recently-viewed-track]");
      if (!track || container.closest("cart-drawer")?.classList.contains("is-empty")) {
        container.hidden = true;
        return;
      }

      const excluded = new Set((container.dataset.cartHandles || "").split(",").filter(Boolean));
      const products = readProducts().filter((product) => !excluded.has(product.handle));
      track.replaceChildren(...products.map(createCard));
      container.hidden = products.length === 0;
    });
  };

  writeCurrentProduct();
  document.addEventListener("DOMContentLoaded", render);
  document.addEventListener("shopify:section:load", render);
  document.addEventListener("click", (event) => {
    if (event.target.closest('[href*="/cart"], [aria-controls="CartDrawer"]')) {
      window.setTimeout(render, 150);
    }
  });

  const observer = new MutationObserver((mutations) => {
    const drawerWasReplaced = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) =>
          node.nodeType === Node.ELEMENT_NODE &&
          (node.matches("[data-cart-recently-viewed]") || node.querySelector("[data-cart-recently-viewed]"))
      )
    );
    if (drawerWasReplaced) window.requestAnimationFrame(render);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
